import { render, staticRenderFns } from "./AdvertisingWidget.vue?vue&type=template&id=53ec92cd&scoped=true"
import script from "./AdvertisingWidget.vue?vue&type=script&lang=js"
export * from "./AdvertisingWidget.vue?vue&type=script&lang=js"
import style0 from "./AdvertisingWidget.vue?vue&type=style&index=0&id=53ec92cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ec92cd",
  null
  
)

export default component.exports